module.exports = __webpack_public_path__ + "src/assets/games/41/lily0096.jpg";